/**
 * Pricing Constants
 * 
 * Fiyat hesaplama ve ürün arama için varsayılan değerler
 */

export const DEFAULT_PAX_COUNT = 2;
export const DEFAULT_DEPARTURE_DAYS_AHEAD = 10;
/** İlk ziyarette (çerez yokken) fiyatların doğru görünmesi için formda gösterilecek varsayılan tarih: bugünden 2 hafta sonra */
export const DEFAULT_INITIAL_DEPARTURE_DAYS_AHEAD = 14;
export const DEFAULT_PER_PAGE = 12;

// Yacht için varsayılan tarih aralığı
export const DEFAULT_YACHT_CHECK_IN_DAYS_AHEAD = 15; // Bugünden 15 gün sonra başlangıç
export const DEFAULT_YACHT_RENTAL_DAYS = 7; // 7 günlük kiralama süresi
